import { formatPriceThousands } from '@/utils/configs/price.config';
import {
  AS_COUNTRY_MAIN,
  EU_COUNTRY,
  EU_COUNTRY_WITH_GB,
  SEA_COUNTRY,
  TC_COUNTRY,
} from '@/utils/configs/public.config';

import CampaignBase from '../../CampaignBase';

import type { ConfigItem, CampaignBaseProps, ProductInfo, Gift } from '../../type';

/** 帆布包价格表 */
const canvasBagPriceTable = [
  {
    'commodity_id': 3686,
    'area': 'DE',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'HK',
    'currency': 'HKD',
    'origin_amount': 199,
  },
  {
    'commodity_id': 3686,
    'area': 'TW',
    'currency': 'TWD',
    'origin_amount': 899,
  },
  {
    'commodity_id': 3686,
    'area': 'PT',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'DK',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'LT',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'LU',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'HR',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'LV',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'HU',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'MC',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'ID',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'IE',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'US',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'EE',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'MO',
    'currency': 'HKD',
    'origin_amount': 199,
  },
  {
    'commodity_id': 3686,
    'area': 'AD',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'IL',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'AE',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'IN',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'MT',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'IS',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'MX',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'IT',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'MY',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'ES',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'AT',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'AU',
    'currency': 'AUD',
    'origin_amount': 35,
  },
  {
    'commodity_id': 3686,
    'area': 'VN',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'RO',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'NL',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'NO',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'RU',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'BE',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'FI',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'BG',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'JP',
    'currency': 'JPY',
    'origin_amount': 3500,
  },
  {
    'commodity_id': 3686,
    'area': 'BN',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'NZ',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'FR',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'SA',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'BR',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'SE',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'SG',
    'currency': 'SGD',
    'origin_amount': 30,
  },
  {
    'commodity_id': 3686,
    'area': 'SI',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'SK',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'GB',
    'currency': 'GBP',
    'origin_amount': 19.99,
  },
  {
    'commodity_id': 3686,
    'area': 'CA',
    'currency': 'CAD',
    'origin_amount': 34.99,
  },
  {
    'commodity_id': 3686,
    'area': 'CH',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'KR',
    'currency': 'KRW',
    'origin_amount': 29000,
  },
  {
    'commodity_id': 3686,
    'area': 'GR',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'KW',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'TH',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'CY',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'CZ',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'PH',
    'currency': 'USD',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'PL',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
  {
    'commodity_id': 3686,
    'area': 'LI',
    'currency': 'EUR',
    'origin_amount': 24.99,
  },
];
/** T恤价格表 */
const tsPriceTable = [
  { 'commodity_id': 3484, 'area': 'DE', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'HK', 'origin_amount': 240 },
  { 'commodity_id': 3484, 'area': 'TW', 'origin_amount': 1099 },
  { 'commodity_id': 3484, 'area': 'PT', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'DK', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'LT', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'LU', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'HR', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'LV', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'HU', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'MC', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'ID', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'IE', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'US', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'EE', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'MO', 'origin_amount': 240 },
  { 'commodity_id': 3484, 'area': 'AD', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'IL', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'AE', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'IN', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'MT', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'IS', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'MX', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'IT', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'MY', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'ES', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'AT', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'AU', 'origin_amount': 49.99 },
  { 'commodity_id': 3484, 'area': 'VN', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'RO', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'NL', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'NO', 'origin_amount': 32.99 },
  { 'commodity_id': 3484, 'area': 'RU', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'BE', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'FI', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'BG', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'JP', 'origin_amount': 4000 },
  { 'commodity_id': 3484, 'area': 'BN', 'origin_amount': 34.99 },
  { 'commodity_id': 3484, 'area': 'NZ', 'origin_amount': 33.99 },
  { 'commodity_id': 3484, 'area': 'FR', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'SA', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'BR', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'SE', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'SG', 'origin_amount': 45 },
  { 'commodity_id': 3484, 'area': 'SI', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'SK', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'GB', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'CA', 'origin_amount': 39.99 },
  { 'commodity_id': 3484, 'area': 'CH', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'KR', 'origin_amount': 42000 },
  { 'commodity_id': 3484, 'area': 'CN', 'origin_amount': 199 },
  { 'commodity_id': 3484, 'area': 'GR', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'KW', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'TH', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'CY', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'CZ', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'PH', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'PL', 'origin_amount': 29.99 },
  { 'commodity_id': 3484, 'area': 'LI', 'origin_amount': 29.99 },
];

const disabledCountries = ['JP', 'AU', 'NZ', 'CN'];

const threeDays = 3 * 24 * 60 * 60 * 1000;

/**
  北京时间：2025/3/20 16:00 - 4/1 16:00
  地区：Global except JP, NZ, AU, South Eastern Asia(SG MY ID TH PH VN BN)
  语言：TC KR EN DE FR IT ES
 */
const globalCDTime = [1742457600000, 1743494400000];
/**
  北京时间：2025/3/20 16:00 - 4/8 16:00
  地区：South Eastern Asia(SG MY ID TH PH VN BN)
  语言：EN
 */
const SEACDTime = [1742457600000, 1744099200000];

const getCountdownTime = (code: string) => {
  return SEA_COUNTRY.includes(code) ? SEACDTime : globalCDTime;
};

const textDomain = 'activity.2025NewLife';
const EOSTextDomain = 'activity.2024EOS';

/**
 * 落地页相关配置
 */
class LandingPageConfig {
  CountryCode: string;
  country: TBasicCountryInfo;
  LANG: Record<string, string>;
  isMobile: boolean;
  X_Language: X_Language;
  buriedPointName: string;
  countDownTime: number[];
  enabled!: boolean;
  isLastWeek!: boolean;

  constructor(info: {
    code: string;
    LANG: LANG;
    X_Language: X_Language;
    isMobile: boolean;
    country: TBasicCountryInfo;
  }) {
    const { code, LANG, X_Language, isMobile, country } = info;
    this.CountryCode = code;
    this.country = country;
    this.LANG = LANG;
    this.isMobile = isMobile;
    this.X_Language = X_Language;
    this.buriedPointName = this.getBuriedPointName();
    this.countDownTime = getCountdownTime(code);
    Object.assign(this, this.getStateConfig());
  }

  getStateConfig = () => {
    const code = this.CountryCode;
    const cdtime = this.countDownTime;
    const now = new Date().getTime();
    return {
      enabled: now > cdtime[0] && now < cdtime[1] && !disabledCountries.includes(code), // 落地页是否开启
      isLastWeek: cdtime[1] - now < threeDays,
    };
  };

  getKvConfig = () => {
    const { isLastWeek, X_Language, isMobile } = this;
    const dataSource = {
      lastWeek: isLastWeek,
      kvFrontImg: isMobile
        ? 'https://res.insta360.com/static/1d3cb800ba39cbcabfa6e875f7afd8e1/kv-front-mo(1).png'
        : 'https://res.insta360.com/static/10b78a4ad64c3415f60943ca044d37dd/SEA%E6%B5%85%E8%89%B2%E7%89%88%E6%9C%AC-%E4%B8%8D%E5%B8%A6%E5%BA%95%E8%89%B2%E7%89%88%E6%9C%AC.png',
      kvTextUrl: (isMobile
        ? {
            'en_us': 'https://res.insta360.com/static/c5baaaebeea7b9ed0dcf3ec5e4e0b7bf/en-mo.svg',
            'de_de': 'https://res.insta360.com/static/877555457361c3066b2c5d89882b83c0/de-mo.svg',
            'es_es': 'https://res.insta360.com/static/0aeb0445465099a5ac021cf40ae47549/es-mo.svg',
            'fr_fr': 'https://res.insta360.com/static/380a5062a73bda4298ad3b64fc38dc93/fr-mo.svg',
            'it_it': 'https://res.insta360.com/static/f393732a4072ec573583825aa3dc2ed4/it-mo.svg',
            'ja_jp': 'https://res.insta360.com/static/c5baaaebeea7b9ed0dcf3ec5e4e0b7bf/en-mo.svg',
            'ko_kr': 'https://res.insta360.com/static/a8e48f4fd6588e60fd9cdc2eb6e66f42/kr-mo.svg',
            'zh_cn': 'https://res.insta360.com/static/c5baaaebeea7b9ed0dcf3ec5e4e0b7bf/en-mo.svg',
            'zh_tw': 'https://res.insta360.com/static/2100246db6892451931facc224d8fa21/slogan-tc-mo.svg',
          }
        : {
            'en_us': 'https://res.insta360.com/static/0b10f3d2cf0164181fd0dd2f6c71b4d5/en.svg',
            'de_de': 'https://res.insta360.com/static/1bb832c7de72504848d8d615581f8c51/de.svg',
            'es_es': 'https://res.insta360.com/static/b4ab94b9c650a088ce6d14fd997ef36b/es.svg',
            'fr_fr': 'https://res.insta360.com/static/8bc1b67602a7e8b0094b5bec148aaf2b/fr.svg',
            'it_it': 'https://res.insta360.com/static/a0ffae1f8b4c99c922b1d74f781a5b65/it.svg',
            'ja_jp': 'https://res.insta360.com/static/0b10f3d2cf0164181fd0dd2f6c71b4d5/en.svg',
            'ko_kr': 'https://res.insta360.com/static/5880f861c900ee2f05504244464206ce/kr.svg',
            'zh_cn': 'https://res.insta360.com/static/0b10f3d2cf0164181fd0dd2f6c71b4d5/en.svg',
            'zh_tw': 'https://res.insta360.com/static/df7b73d39f240f0b1cccb4f562d612cc/slogan-tc.svg',
          })[X_Language],
      kvTextUrlCD: (isMobile
        ? {
            'en_us': 'https://res.insta360.com/static/e3d30d7d81eab9256cbac1a4c0a03711/en-mo.svg',
            'de_de': 'https://res.insta360.com/static/f1c1705ba2b79a13e0c09bbc04889691/de-mo.svg',
            'es_es': 'https://res.insta360.com/static/ef3e7d72cc5380b5ae76c680ff202511/es-mo.svg',
            'fr_fr': 'https://res.insta360.com/static/bb228e2e6b2667a9831876c4932f311a/fr-mo.svg',
            'it_it': 'https://res.insta360.com/static/b31ce94a6279386fca660595112b1572/it-mo.svg',
            'ja_jp': 'https://res.insta360.com/static/e3d30d7d81eab9256cbac1a4c0a03711/en-mo.svg',
            'ko_kr': 'https://res.insta360.com/static/24bbe5dd4a42f80ba32fceb12bbf7332/kr-mo.svg',
            'zh_cn': 'hhttps://res.insta360.com/static/e3d30d7d81eab9256cbac1a4c0a03711/en-mo.svg',
            'zh_tw': 'https://res.insta360.com/static/2dd671242481b115df6f26eca98edf03/slogan-tc-mo-cd.svg',
          }
        : {
            'en_us': 'https://res.insta360.com/static/655852e02773444339836aca5436b710/en.svg',
            'de_de': 'https://res.insta360.com/static/36d9875de74bca4efc884628e7402db4/de.svg',
            'es_es': 'https://res.insta360.com/static/09d4e5fd361086e13d5014052cc26be2/es.svg',
            'fr_fr': 'https://res.insta360.com/static/fcd56574a98920b9803347f76f9fb326/fr.svg',
            'it_it': 'https://res.insta360.com/static/e9b1671d4dc3977c77e938564a708a35/it.svg',
            'ja_jp': 'https://res.insta360.com/static/655852e02773444339836aca5436b710/en.svg',
            'ko_kr': 'https://res.insta360.com/static/477a7af2835614e13c93326fb1689dfe/kr.svg',
            'zh_cn': 'https://res.insta360.com/static/655852e02773444339836aca5436b710/en.svg',
            'zh_tw': 'https://res.insta360.com/static/88c7d363bb648eb95353145270d40057/slogan-tc-cd.svg',
          })[X_Language],
    };

    return dataSource;
  };

  getCountDownConfig = () => {
    if (!this.enabled) return { end: 0 };
    return {
      end: this.countDownTime[1],
    };
  };

  getProductConfig = (isTablet: boolean) => {
    const { LANG, isMobile: ismo, CountryCode: code } = this;
    // 平板端使用pc素材（高清
    const isMobile = ismo && !isTablet;

    // 周边赠品配置, 地区范围与活动一致
    const periphery: Gift[] = [
      {
        commodityId: 3488,
        disabled: !AS_COUNTRY_MAIN.includes(code),
        displayUrl: 'https://res.insta360.com/static/b1f0c25ff27934c4b7b8b2cf9042763c/T%E6%81%A4.png',
        commodityName: LANG[`${EOSTextDomain}.LP.gift_name`] || '',
        number: 1,
      },
      // {
      //   commodityId: 3686,
      //   disabled: AS_COUNTRY_MAIN.concat(['US']).includes(code),
      //   displayUrl: 'https://res.insta360.com/static/831757d0823831e480fe59ab58e17273/bag_gift.png',
      //   commodityName: LANG[`${EOSTextDomain}.LP.gift_name_bag`] || '',
      //   number: 1,
      // },
    ].filter((g) => !g.disabled);

    const config: ConfigItem[] = [
      {
        type: 'X4',
        anchor: LANG[`${textDomain}.Nav.X4`],
        tag: LANG[`Campaign.Flagship`],
        videoConfig: {
          url: isMobile
            ? 'https://media.insta360.com/static/282356d4852e56f5b2f21a395a6ef15f/8K%2030%20mob.mp4'
            : 'https://media.insta360.com/static/0188a1c7e3495f3adf8edda86edc99aa/8k%20360%20Full%201020-580.mp4',
          poster: isMobile
            ? 'https://res.insta360.com/static/f630a2a2375462634499a3c93ef99756/8K-30_654_490.jpeg'
            : 'https://res.insta360.com/static/ed432affbcdacd8323bafb9589c3103b/8K-30.jpg',
        },
        cids: [
          {
            id: 2994,
            master: 'https://res.insta360.com/static/c7bb99bf047a597f2052e83dfb1d3561/PNG.png',
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.360camera`],
              LANG[`Campaign.featTags.thirdperson`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.Snowboarding`],
            ],
          },
          {
            id: 2997,
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.360camera`],
              LANG[`Campaign.featTags.motorcycling`],
              LANG[`Campaign.featTags.street`],
              LANG[`Campaign.featTags.offroad`],
            ],
          },
          {
            id: 3001,
            mediaTag: true,
            master: 'https://res.insta360.com/static/08599a0f69ce35da001980d3ca02930f/Invisible%20Dive%20Bundle.png',
            featTags: [
              LANG[`Campaign.featTags.360camera`],
              LANG[`Campaign.featTags.diving`],
              LANG[`Campaign.featTags.surfing`],
              LANG[`Campaign.featTags.swimming`],
            ],
          },
          {
            id: 2995,
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.360camera`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.hiking`],
              LANG[`Campaign.featTags.vlog`],
            ],
          },
        ],
        feats: [
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.x4.f1`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/bb39dd0297f7e272871e2fffeb1baca0/8k%20360%20mob.mp4'
                : 'https://media.insta360.com/static/3a03050bd5dfae8408f7cd6507a05ee1/8k%20360%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/e68c2c42c7bdd2afe3fa18beeac3d0fd/X4-F1-mo.jpg'
                : 'https://res.insta360.com/static/6d1f0767cb3ddde4b537514dfa064e11/X4-F1.jpg',
              length: '5000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.x4.f2`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/1dfd554cb9808506f72a578c2c90ac0f/x4-f2-mo.mp4'
                : 'https://media.insta360.com/static/4d0bc7c35b7025fa9626f41e710d32d7/x4-f2.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/3fb04d3b567329c402163220be0ba37d/x4-f2-mo.jpg'
                : 'https://res.insta360.com/static/a835fec3da3de9004b4225011535f6b4/x4-f2.jpg',
              length: '4000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.x4.f3`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/b9ab940308e100942afe5f1b9e47e2e8/Invisible%20selfie%20stick%20mob_1.mp4'
                : 'https://media.insta360.com/static/cbecbc29041813f40a2206350a8afebd/Invisible%20selfie%20stick%20PC_1.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/90ba6fc41c421cf7f7de309beb8ea2fd/X4-F2-mo.jpg'
                : 'https://res.insta360.com/static/3ba96805215597d86da6f34c1d2af8ab/X4-F2.jpg',
              length: '4000',
            },
            scale: isMobile ? 1 : 1.05,
          },
        ],
      },
      {
        type: 'Go',
        anchor: LANG[`${textDomain}.Nav.GO`],
        tag: LANG[`Campaign.Wearable`],
        videoConfig: {
          url: 'https://media.insta360.com/static/d2f8cd34f56f50e141819a88e9e7b232/go3.mp4',
          poster: 'https://res.insta360.com/static/d25aecfd668257179d0682758d5fe881/poster.jpg',
        },
        cids: [
          {
            id: 3120,
            master: 'https://res.insta360.com/static/b791b5721535361f982b4ca1986e529b/Go3.png',
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.pov`],
              LANG[`Campaign.featTags.firstperson`],
              LANG[`Campaign.featTags.SoloTraveling`],
              LANG[`Campaign.featTags.VlogInPublic`],
              LANG[`Campaign.featTags.RoadCycling`],
            ],
          },
          {
            id: 3469,
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.pov`],
              LANG[`Campaign.featTags.firstperson`],
              LANG[`Campaign.featTags.LifestyleVlog`],
              LANG[`Campaign.featTags.CoupleTraveling`],
              LANG[`Campaign.featTags.family`],
            ],
          },
          {
            id: 3121,
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.pov`],
              LANG[`Campaign.featTags.firstperson`],
              LANG[`Campaign.featTags.family`],
              LANG[`Campaign.featTags.CoupleTraveling`],
              LANG[`Campaign.featTags.LifestyleVlog`],
            ],
          },
          {
            id: 3122,
            featTags: [
              LANG[`Campaign.featTags.pov`],
              LANG[`Campaign.featTags.firstperson`],
              LANG[`Campaign.featTags.RoadCycling`],
              LANG[`Campaign.featTags.hiking`],
              LANG[`Campaign.featTags.Running`],
            ],
          },
          {
            id: 2376,
            periphery,
            featTags: [
              LANG[`Campaign.featTags.pov`],
              LANG[`Campaign.featTags.firstperson`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.vlog`],
              LANG[`Campaign.featTags.cycling`],
            ],
          },
        ],
        feats: [
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.go3.f1`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/ca51aaa52ace852d8a9b3c9f5687e87c/Small%20and%20light%20mob.mp4'
                : 'https://media.insta360.com/static/ef62790c469ddb57048768b62a39f164/Small%20and%20light%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/3fc2aa0234395cc45d295980f1934c3f/Small%20and%20light%20mob.jpg'
                : 'https://res.insta360.com/static/a9475878723307bed93d44ec180f1789/Small%20and%20light%20PC.jpg',
              length: '2000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.go3.f2`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/f8a8427ce344daf77636019995cca1ae/Hands%20free%20mob.mp4'
                : 'https://media.insta360.com/static/eaf11b420896ae09aa72bb44eb932629/Hands%20free%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/310deb34b0a8988200fd7576aca65bfa/Hands%20free%20mob.jpg'
                : 'https://res.insta360.com/static/9fcba2ef6dbaa11924166293a8866b8d/Hands%20free%20PC.jpg',
              length: '3000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.go3.f3`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/396f65d678231ba9148e2542f58e417d/Mount%20anywhere%20mob.mp4'
                : 'https://media.insta360.com/static/12c917ed4b37e52c75477765fda3e154/Mount%20anywhere%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/25a2752fe02469898426fcf4bada680c/Mount%20anywhere%20mob.jpg'
                : 'https://res.insta360.com/static/9b9db807bdb428a1cfdd9fc2ed89641e/Mount%20anywhere%20PC.jpg',
              length: '5000',
            },
          },
        ],
      },
      {
        type: 'AcePro2',
        anchor: LANG[`${textDomain}.Nav.Ace2`],
        tag: LANG[`Campaign.ProGrade`],
        videoConfig: {
          url: 'https://media.insta360.com/static/e133e477cd4b7e9c3b787366c176c22d/test.mp4',
          poster: 'https://res.insta360.com/static/3aa539ffe00ec463fa3a28e1261d4e76/test.jpg',
        },
        cids: [
          {
            id: 3611,
            master: 'https://res.insta360.com/static/9f69d26cfae5ef7bf280d80501539d3a/acepro2(1).png',
            featTags: [
              LANG[`Campaign.featTags.action`],
              LANG[`Campaign.featTags.NightShooting`],
              LANG[`Campaign.featTags.motorcycling`],
              LANG[`Campaign.featTags.diving`],
            ],
          },
          {
            id: 3612,
            featTags: [
              LANG[`Campaign.featTags.action`],
              LANG[`Campaign.featTags.NightShooting`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.ContentCreation`],
            ],
          },
          {
            id: 3616,
            featTags: [
              LANG[`Campaign.featTags.action`],
              LANG[`Campaign.featTags.NightShooting`],
              LANG[`Campaign.featTags.motorcycling`],
              LANG[`Campaign.featTags.street`],
            ],
          },
          {
            id: 3617,
            featTags: [
              LANG[`Campaign.featTags.action`],
              LANG[`Campaign.featTags.diving`],
              LANG[`Campaign.featTags.swimming`],
            ],
          },
          {
            id: 3619,
            featTags: [
              LANG[`Campaign.featTags.action`],
              LANG[`Campaign.featTags.NightShooting`],
              LANG[`Campaign.featTags.motorcycling`],
              LANG[`Campaign.featTags.diving`],
            ],
          },
        ],
        feats: [
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.ace.f1`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/e9a171e3bb8fbccdf683c179105af2b1/Purevideo%201026-660.mp4'
                : 'https://media.insta360.com/static/9fe7f5151398c292f9c44f1b21965ec3/Purevideo%201118.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/459fadcc4668d2666905bcbeb7d1f148/Purevideo%201026-660_frame1.jpg'
                : 'https://res.insta360.com/static/fd4a57c196a8038b529b9580a3af8779/Purevideo%201280-960%20%E5%B8%A6%E9%BB%91%E8%BE%B9_cover.jpg',
              length: '4000',
              comparison: {
                left: LANG[`${EOSTextDomain}.LP.vidfeats.pureOff`],
                right: LANG[`${EOSTextDomain}.LP.vidfeats.pureOn`],
              },
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.ace.f2`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/c301ade868f170c76ae8de6232e987e3/HDR%201026-660.mp4'
                : 'https://media.insta360.com/static/bb110177a3e9acf673d3cf5014df2813/HDR%201280-720.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/47bbffae97def3dc549da4cc48ec9068/HDR%201026-660_frame1.jpg'
                : 'https://res.insta360.com/static/df41fb4b2d16e2036e9d14a239e0f5e6/HDR%201280-720_frame1.jpg',
              length: '4000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.ace.f3`],
            video: {
              poster: isMobile
                ? 'https://res.insta360.com/static/fcd4b6adb07b438b14f402a3f201ec8b/Superior%20Audio-mo.jpg'
                : 'https://res.insta360.com/static/ad1feeae4b96ec3c9a8fb9ce3ce2229b/Superior%20Audio.jpg',
            },
          },
        ],
      },
      {
        type: 'X3X2',
        showGifts: true,
        anchor: LANG[`${textDomain}.Nav.X3X2`],
        tag: LANG[`Campaign.Versatile`],
        periphery,
        videoConfig: {
          url: isMobile
            ? 'https://media.insta360.com/static/infr_base/cbd6654db90d292ec4e07e3755163454/%E9%A3%9E%E4%B9%A620221031-180923.mp4'
            : 'https://media.insta360.com/static/5dc174ebf755fe2d47df531450286182/X3-1020-580.mp4',
          poster: isMobile
            ? 'https://res.insta360.com/static/infr_base/f8f933864a4a2e0988cc2a674afdc936/x3-mob.jpg'
            : 'https://res.insta360.com/static/869b83fddfbd57300667c1cb2b00759e/X3-1020-580.jpg',
        },
        cids: [
          {
            id: 2118,
            // master: 'https://res.insta360.com/static/b057c840aeb51f66e091138ffa425ed7/%E4%B8%BB%E5%9B%BE=X3.png',
            featTags: [
              LANG[`Campaign.featTags.360camera`],
              LANG[`Campaign.featTags.thirdperson`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.Snowboarding`],
            ],
          },
          {
            id: 1164,
            // master: 'https://res.insta360.com/static/b057c840aeb51f66e091138ffa425ed7/%E4%B8%BB%E5%9B%BE=X3.png',
            featTags: [
              LANG[`Campaign.featTags.360camera`],
              LANG[`Campaign.featTags.cycling`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.diving`],
            ],
          },
          {
            id: 2591,
            master: 'https://res.insta360.com/static/1c1a41d2d5502dd0a15647bcaa191eac/Motorcycle%20Bundle.png',
            featTags: [
              LANG[`Campaign.featTags.360camera`],
              LANG[`Campaign.featTags.motorcycling`],
              LANG[`Campaign.featTags.street`],
              LANG[`Campaign.featTags.offroad`],
            ],
          },
          {
            id: 2224,
            master: 'https://res.insta360.com/static/931a4a756e50176d7da700bc358bf987/Get-Set%20Bundle.png',
            featTags: [
              LANG[`Campaign.featTags.360camera`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.hiking`],
              LANG[`Campaign.featTags.vlog`],
            ],
          },
        ],
        feats: [
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.x3.f1`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/1c2f276cfb78575fa08595d377b9aec1/5.7k%20360%20mob.mp4'
                : 'https://media.insta360.com/static/7247d9ee944e061896ce7b812b96f1c1/5.7k%20360%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/1f28d97568e41ac463706805d105cd16/5.7k%20360%20mob.jpg'
                : 'https://res.insta360.com/static/5f459f0d6548a91397fed01d50741899/5.7k%20360%20PC.jpg',
              length: '3000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.x3.f2`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/a53665fe44ab234ef94a81bc374deb27/Invisible%20Selfie%20Stick%20mob.mp4'
                : 'https://media.insta360.com/static/85ba690c23d5e8c76f0f3e7ebf61f8d1/Invisible%20Selfie%20Stick%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/41a43c1b87e1ea7c3dd7e7e75c6615cd/Invisible%20Selfie%20Stick%20mob.jpg'
                : 'https://res.insta360.com/static/13e69b475676bfe87f039c3cf5506a71/Invisible%20Selfie%20Stick%20PC.jpg',
              length: '6000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.x3.f3`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/23bb37aa495264c63abc988bb2be8bd9/Flowstate%20mob.mp4'
                : 'https://media.insta360.com/static/e9a39bce959564443f519f6340921add/Flowstate%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/d4da8e59a81c8c71f452a6aa71584c90/Flowstate%20mob.jpg'
                : 'https://res.insta360.com/static/cdf306ae53d8ec246e513d5df7e001e4/Flowstate%20PC.jpg',
              length: '4000',
              comparison: {
                left: LANG[`${EOSTextDomain}.LP.vidfeats.off`],
                right: LANG[`${EOSTextDomain}.LP.vidfeats.on`],
              },
            },
          },
        ],
      },
      {
        type: 'AcePro',
        showGifts: true,
        tag: LANG['Campaign.Versatile'],
        anchor: LANG[`${textDomain}.Nav.Ace`],
        // pic: 'https://res.insta360.com/static/089aa55ab51d367689006a4186ebd04e/736A4015_%E4%BA%AE%E5%B1%8F%E5%B9%95%201%20(1).jpg',
        periphery,
        videoConfig: {
          url: isMobile
            ? 'https://media.insta360.com/static/5c038b8a8fc5f36cfda035323942ea39/X2%20mob.mp4'
            : 'https://media.insta360.com/static/infr_base/89a07925a3124b6bae1bb3b573d4f91a/X2%20pc.mp4',
          poster: isMobile
            ? 'https://res.insta360.com/static/2c9e2ec1103d5459f308e07d0b2298d2/X2%20mob.jpg'
            : 'https://res.insta360.com/static/578928eb904fb8d1849b2852cd78011b/X2%20pc.00_00_14_15.Still001.jpg',
        },
        cids: [
          {
            id: 2641,
            master: 'https://res.insta360.com/static/06dd0ebdbd3d69baa8893dd9836d15cd/ace(1).png',
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.action`],
              LANG[`Campaign.featTags.NightShooting`],
              LANG[`Campaign.featTags.motorcycling`],
              LANG[`Campaign.featTags.diving`],
            ],
          },
          {
            id: 2688,
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.action`],
              LANG[`Campaign.featTags.NightShooting`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.vlog`],
            ],
          },
          {
            id: 2689,
            featTags: [
              LANG[`Campaign.featTags.action`],
              LANG[`Campaign.featTags.NightRiding`],
              LANG[`Campaign.featTags.motorcycling`],
              LANG[`Campaign.featTags.street`],
            ],
          },
        ],
        feats: [
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.ace.f4`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/3f6db139c8b676c1e1a85befedcd7020/Pure%20video%20mob.mp4'
                : 'https://media.insta360.com/static/3a7a443d27afe7a6b025f57e549770f0/Pure%20video%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/97e20f413cdafca5ef08eddb6cb779d1/Pure%20video%20mob.jpg'
                : 'https://res.insta360.com/static/2b3fd0c2421365fb814458d0ba21dd1b/Pure%20video%20PC.jpg',
              length: '4000',
              comparison: {
                left: LANG[`${EOSTextDomain}.LP.vidfeats.pureOff`],
                right: LANG[`${EOSTextDomain}.LP.vidfeats.pureOn`],
              },
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.ace.f5`],
            video: {
              poster: isMobile
                ? 'https://res.insta360.com/static/61f0aac752a078c1bfddf31768a5b8ce/1-1.3%20%E2%80%9C%E6%84%9F%E5%85%89%E5%85%83%E4%BB%B6.jpg'
                : 'https://res.insta360.com/static/daf78585b370ac8edc1d980cbfbb37c2/1.3%20%E2%80%9C%E6%84%9F%E5%85%89%E5%85%83%E4%BB%B6.png',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.ace.f6`],
            video: {
              poster: 'https://res.insta360.com/static/d793985f81f806fe8d4c03d080d6481b/ace-f3.jpg',
            },
          },
        ],
      },
      {
        type: 'Flow',
        anchor: LANG[`${textDomain}.Nav.Flow`],
        tag: LANG[`Campaign.best_seller_tag`],
        videoConfig: {
          url: isMobile
            ? 'https://media.insta360.com/static/74de84a88a3cc390488c13e5a71ac858/MO.mp4.mp4'
            : 'https://media.insta360.com/static/9a78f01048239e87f237754f6dca7151/FLOW-1020-580.mp4',
          poster: isMobile
            ? 'https://res.insta360.com/static/3f26803b0064a2a1c435bd69d4491b15/MO_cover.jpg'
            : 'https://res.insta360.com/static/24e5814407f6620767f449cd12c3eaac/FLOW-1020-580.jpg',
        },
        cids: [
          {
            id: 3782,
            featTags: [
              LANG[`Campaign.featTags.gimbal`],
              LANG[`Campaign.featTags.vlog`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.live`],
            ],
          },
          {
            id: 2220,
            featTags: [
              LANG[`Campaign.featTags.gimbal`],
              LANG[`Campaign.featTags.travel`],
              LANG[`Campaign.featTags.basketball`],
              LANG[`Campaign.featTags.dancing`],
            ],
          },
          {
            id: 3781,
            featTags: [
              LANG[`Campaign.featTags.gimbal`],
              LANG[`Campaign.featTags.ContentCreation`],
              LANG[`Campaign.featTags.live`],
              LANG[`Campaign.featTags.vlog`],
            ],
          },
        ],
        feats: [
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.flow.f1`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/d64b6e9bdb1cd672e56d017c500dbbff/Deep%20track%203.0%20mob.mp4'
                : 'https://media.insta360.com/static/cd8d9df8e1d601fdc33265f535c8f44f/Deep%20track%203.0%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/7de28632205fac5fc8370e2b916f3abc/Deep%20track%203.0%20mob.jpg'
                : 'https://res.insta360.com/static/01422b4f8e37574c882aa08133671ade/Deep%20track%203.0%20PC.jpg',
              length: '4000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.flow.f2`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/d519c5a7fbf1392b8a49afe7f8ab8ed4/BUILT-IN%20SELFIE%20STICK%20mob.mp4'
                : 'https://media.insta360.com/static/eaf4bfd42f7af85a869b56ad797d865a/BUILT-IN%20SELFIE%20STICK%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/884a88624e292d7a1f0bcc1b3bae020e/BUILT-IN%20SELFIE%20STICK%20mob.jpg'
                : 'https://res.insta360.com/static/058563da129a935090bc343f7701ce25/BUILT-IN%20SELFIE%20STICK%20PC.jpg',
              length: '4000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.flow.f3`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/60ee5b80febf001c1ed63fa7e223805c/3-axis%20stabiliztion%20mob.mp4'
                : 'https://media.insta360.com/static/58d963e27fa66b770d82a42d6b31d78d/3-axis%20stabiliztion%20PC.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/a2c58b0d8086cf8cbf32965ae4370d69/3-axis%20stabiliztion%20mob.jpg'
                : 'https://res.insta360.com/static/d3709073cf004f46b9481de8cbadbc03/3-axis%20stabiliztion%20PC.jpg',
              length: '3000',
              comparison: {
                left: LANG[`${EOSTextDomain}.LP.vidfeats.handOff`],
                right: LANG[`${EOSTextDomain}.LP.vidfeats.handOn`],
              },
            },
          },
        ],
      },
      {
        type: 'Link',
        anchor: LANG[`${textDomain}.Nav.Link`],
        layoutType: 3,
        tag: LANG[`Campaign.best_price_tag`],
        videoConfig: {
          url: isMobile
            ? 'https://media.insta360.com/static/5c038b8a8fc5f36cfda035323942ea39/X2%20mob.mp4'
            : 'https://media.insta360.com/static/infr_base/89a07925a3124b6bae1bb3b573d4f91a/X2%20pc.mp4',
          poster: isMobile
            ? 'https://res.insta360.com/static/2c9e2ec1103d5459f308e07d0b2298d2/X2%20mob.jpg'
            : 'https://res.insta360.com/static/578928eb904fb8d1849b2852cd78011b/X2%20pc.00_00_14_15.Still001.jpg',
        },
        cids: [
          {
            id: 3401,
            master: 'https://res.insta360.com/static/8ba72f48327016246f3c41090febe767/link2(1).png',
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.conference`],
              LANG[`Campaign.featTags.onlineClass`],
              LANG[`Campaign.featTags.live`],
              LANG[`Campaign.featTags.gaming`],
            ],
          },
          {
            id: 3403,
            mediaTag: true,
            featTags: [
              LANG[`Campaign.featTags.conference`],
              LANG[`Campaign.featTags.onlineClass`],
              LANG[`Campaign.featTags.live`],
              LANG[`Campaign.featTags.gaming`],
            ],
          },
          {
            id: 1980,
            mediaTag: true,
            master:
              'https://res.insta360.com/static/04480f923c7da8f2d40336960f0847bc/%E4%B8%BB%E5%9B%BE=One%20Link.png',
            featTags: [
              LANG[`Campaign.featTags.conference`],
              LANG[`Campaign.featTags.onlineClass`],
              LANG[`Campaign.featTags.live`],
              LANG[`Campaign.featTags.gaming`],
            ],
          },
        ],
        feats: [
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.link.f1`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/4c6ef9ea96724c270e8e5282a0c4084e/4KResolution%201026-660.mp4'
                : 'https://media.insta360.com/static/3e6d40a8a12d6a0aaf00180e6384df75/4KResolution%201280-960.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/a1defb4fe4cd04ff9b43b936451190b1/4KResolution%201026-660_frame1.jpg'
                : 'https://res.insta360.com/static/c1395e0812dbc3a8fb996b21959f0645/4KResolution%201280-960_frame1.jpg',
              length: '4000',
              comparison: {
                left: LANG[`${EOSTextDomain}.LP.vidfeats.4kOff`],
                right: LANG[`${EOSTextDomain}.LP.vidfeats.4kOn`],
              },
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.link.f2`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/190f121ae5c7cbbeba897f7501aae43d/AI%20Framing%201026-660.mp4'
                : 'https://media.insta360.com/static/214410d175c808d3575ffc520ccebbef/AI%20Framing%201280-960mp4.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/013fc9a45e070f9d0d39ebbb16852406/AI%20Framing%201026-660_frame1.jpg'
                : 'https://res.insta360.com/static/a6859f548f422e1c0cd9e81ac4947cf0/AI%20Framing%201280-960mp4_frame1.jpg',
              length: '5000',
            },
          },
          {
            name: LANG[`${EOSTextDomain}.LP.vidfeats.link.f3`],
            video: {
              url: isMobile
                ? 'https://media.insta360.com/static/58a53199e7e19671a1e2a75d29b9da16/AI%20Noise-Cancelling_1026-660.mp4'
                : 'https://media.insta360.com/static/d4a9e03094541401f68b935ee1834950/AI%20Noise-Cancelling_1280-960.mp4',
              poster: isMobile
                ? 'https://res.insta360.com/static/d9923b49bb65746e72f09168c46a871e/AI%20Noise-Cancelling_1026-660_frame1.jpg'
                : 'https://res.insta360.com/static/766076ca869800cdc7a30d58879d2995/AI%20Noise-Cancelling_1280-960_frame1.jpg',
              length: '5000',
            },
          },
        ],
      },
    ];

    if (code === 'KR') {
      // kr将acepro2放第一位
      const apInd = config.findIndex((c) => c.type === 'AcePro2');
      const apc = config.splice(apInd, 1)?.[0];
      config.unshift(apc);
    }

    // 批处理
    config.forEach((c, ind) => {
      // 左右排版
      if (ind % 2 === 1) {
        c.rightLayout = true;
      }
      // 默认布局
      if (!c.layoutType) {
        c.layoutType = 2;
      }

      c.cids.forEach((item) => {
        item.desc = LANG[`${textDomain}.ProductCard.${c.type}.desc_${item.id}`];
        item.c_name = LANG[`${textDomain}.ProductCard.${c.type}.bundle_tab_${item.id}`];
        item.pname = LANG[`${textDomain}.ProductCard.${c.type}.name_${item.id}`];
      });
    });

    return config;
  };

  getAccessoryConfig = (isSM: boolean) => {
    const config = [
      { id: 2993 },
      {
        id: 2629,
        pic: 'https://res.insta360.com/static/c998f2fac65c15719ae22ec54344d42f/2629acc.png',
      },
      {
        id: 1246,
      },
      {
        id: 3639,
        pic: 'https://res.insta360.com/static/6b2b238979a7fbb71e5b2a4fe34a5b05/1.png',
      },
      {
        id: 2853,
        pic: 'https://res.insta360.com/static/12a3a550b53abc459d2869c9810ac589/AV04.png',
      },
      {
        id: 2983,
      },
      {
        id: 3173,
      },
      {
        id: 1162,
      },
      {
        id: 3634,
      },
    ];
    if (this.isMobile && isSM) return config.slice(0, -1);

    return config;
  };

  getBuriedPointName = () => {
    return '2025springsale';
  };
}

/**
 * 非落地页活动相关配置
 */
class SpringSale extends CampaignBase {
  buriedPointName: string;
  activityUrl: string;
  isLastWeek!: boolean;
  isGrayTest: boolean;

  constructor(props: CampaignBaseProps) {
    super(props);
    this.buriedPointName = '2025springsale';
    this.activityUrl = '/spring-sale';
    this.isGrayTest = props.isGrayTest;
    Object.assign(this, this.getStateConfig());
  }

  getStateConfig = () => {
    const cdtime = [this.isGrayTest ? 0 : getCountdownTime(this.CountryCode)[0], getCountdownTime(this.CountryCode)[1]]; // 灰度提前验证
    const now = new Date().getTime();
    return {
      enabled: now > cdtime[0] && now < cdtime[1] && !disabledCountries.includes(this.CountryCode),
      isLastWeek: cdtime[1] - now < threeDays,
    };
  };

  /**
   * 移动端浮窗相关配置
   */
  getHeaderEntry = () => {
    return {
      activityName: this.LANG[`${textDomain}.headerEntryName_ss`] ?? '',
      activityDesc: this.LANG[`${textDomain}.headerEntryDesc_ss`],
      activityUrl: this.activityUrl,
      buriedPointName: this.buriedPointName,
    };
  };

  /**
   * 配置产品页折扣/营销文案
   * 大促上线时，需要注意产品页常驻活动的营销文案，有可能大促上线期间常驻营销文案需要隐藏！！！
   * new: 记得带上isLastWeek字段
   */
  getProductDiscountIntro = (pInfo: ProductInfo) => {
    const { pid } = pInfo;
    const enabledProduct = [6, 13, 15, 18, 19, 22, 24, 25, 26, 27, 29, 30];
    if (!enabledProduct.includes(pid)) return null;
    const { LANG, CountryCode: code } = this;

    let suffix = '';
    if (['US'].includes(code)) {
      suffix = '_us';
    } else if (SEA_COUNTRY.includes(code)) {
      suffix = '_sea';
    } else if (TC_COUNTRY.includes(code)) {
      suffix = '_tc';
    }

    switch (pid) {
      case 19:
        if (EU_COUNTRY_WITH_GB.includes(code)) {
          suffix = '_eu';
        }
        break;
      case 24:
        if (['CA', 'DE', 'IT', 'FR', 'ES', 'GB'].includes(code)) {
          suffix = '_sp';
        } else if (['KR'].includes(code)) {
          suffix = '_kr';
        } else if (['SG', 'PH'].includes(code)) {
          suffix = '_sea1';
        } else if (['BN', 'VN', 'MY', 'ID', 'TH'].includes(code)) {
          suffix = '_sea2';
        }
        break;
      case 13:
        if (EU_COUNTRY.includes(code)) {
          suffix = '_eu';
        }
        break;
      default:
        break;
    }

    let locale = LANG[`${textDomain}.Promotion.ss.promotion_${pid}${suffix}`] || '';
    // 东南亚使用ts价格，其他用canvas bag
    const giftPrice = (['_sea', '_tc', '_sea1', '_sea2'].includes(suffix) ? tsPriceTable : canvasBagPriceTable).find(
      (el) => el.area === code
    );
    locale = locale.replace(
      '_PRICE_',
      ' ' + formatPriceThousands({ price: giftPrice?.origin_amount ?? 0, country: this.country })
    );

    return { text: locale, isTop: true, renderHtml: false, isLastWeek: this.isLastWeek };
  };

  /**
   * 获取倒计时参数
   */
  getCountDownProps = () => {
    const cdt = getCountdownTime(this.CountryCode);
    return {
      timeEnd: cdt ? cdt[1] : undefined,
      index: this.buriedPointName,
      title: this.LANG[`${textDomain}.countDownTitle_ss`],
    };
  };

  /**
   * 产品页赠品文案隐藏特定赠品
   */
  hideGiftIntro = (pid: number) => {
    if (![19, 13, 24, 25].includes(pid)) return false;

    return { giftCids: [3686] }; // 隐藏帆布包
  };
}

export { LandingPageConfig, SpringSale };
